<template>
  <v-app id="inspire">
    <Navigations :breadcrumbs="this.breadcrumb" />
    <v-main>
      <v-container class="py-10">
        <h1 class="mb-10">{{ language.cards.cardtype.business }}</h1>

        <v-row>
          <KyanoCard
            v-for="card in data.cards"
            :key="card.id"
            :data="card"
            :to="data.to"
          />

          <KyanoCardProfileNew :data="data.profiles" />
        </v-row>

        <div class="d-inline-block col-12"></div>
        <h2 class="mb-2 text-primary">Gedeeld met mij</h2>

        <div v-if="data.shared === null">
          <v-card elevation="0" color="#fff" outlined class="pa-4 mb-3">
            <h4
              v-text="'Geen cards gevonden'"
              color="primary"
              class="headline font-weight-bold mx-auto d-block text-primary"
            ></h4>
            <p>Je hebt nog geen gedeelde business cards in je account.</p>
          </v-card>
        </div>
        <div v-else>
          <v-row>
            <KyanoCard
              v-for="card in data.shared.cards"
              :key="card.id"
              :data="card"
              :to="data.to"
            />
          </v-row>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import KyanoCard from "@/components/KyanoCard.vue";
import KyanoCardProfileNew from "@/components/KyanoCardProfileNew.vue";
import Navigations from "@/components/Navigations.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    Navigations,
    KyanoCard,
    KyanoCardProfileNew,
  },
  computed: {
    ...mapGetters({ language: "getlanguage" }),
  },
  data() {
    return {
      breadcrumb: [
        {
          text: "Cards",
          disabled: true,
          href: "/cards",
        },
      ],
      data: {
        shared: {
          cards: [
            {
              id: 1,
              companyname: "Sharedcenter",
              profile_firstname: "Voornaam",
              profile_lastname: "Hesseling",
              function: "Developer",
              card_type: "Businesscard",
              avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
              to: "cards/1",
              isSmallClass: true,
            },
          ],
        },

        cards: [
          {
            id: 1,
            companyname: "Snelwebcenter",
            profile_firstname: "Gianni",
            profile_lastname: "Hesseling",
            function: "Developer",
            card_type: "Businesscard",
            avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
            to: "cards/1",
            isSmallClass: true,
          },
          {
            id: 2,
            companyname: "Snelwebcenter",
            profile_firstname: "Jesper",
            profile_lastname: "van der Weide",
            function: "Developer",
            card_type: "Businesscard",
            avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
            to: "cards/2",
            isSmallClass: true,
          },
        ],

        profiles: [
          {
            id: 1,
            companyname: "Snelwebcenter",
            profile_firstname: "Gianni",
            profile_lastname: "Hesseling",
            function: "Developer",
            card_type: "Businesscard",
            avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
          },
          {
            id: 2,
            companyname: "Snelwebcenter",
            profile_firstname: "Jesper",
            profile_lastname: "van der Weide",
            function: "Developer",
            card_type: "Businesscard",
            avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
          },
          {
            id: 1,
            companyname: "Snelwebcenter",
            profile_firstname: "Gianni",
            profile_lastname: "Hesseling",
            function: "Developer",
            card_type: "Businesscard",
            avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
          },
        ],
      },
    };
  },
};
</script>
